import React, { forwardRef, useEffect, useMemo } from 'react';

// DEPENDENCIES
import get from 'lodash/get';

// GLOBAL VARIABLES
import { SELECT } from 'defaults.js';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions.js';

// LOCAL FUNCTIONS
import { filterOptions, hasValue } from '../functions';

// MAIN COMPONENT
export const validateOptions = Component => forwardRef((props, ref) => {

  // PROPS
  const {
    name,
    options,
    multiple,
    allowCustom = SELECT.allowCustom,
    useCSV = SELECT.useCSV,
    form: {
      initialValues,
      setFieldValue
    } = {},
    skipValidateOptions,
    onLoadOptions
  } = props;

  // MEMOS
  const initialValue = useMemo(
    () => get(initialValues, name),
    [name, initialValues]
  )
  const initialOptions = useMemo(
    () => filterOptions(initialValue, options, multiple),
    [options, multiple, initialValue]
  )

  // EFFECTS
  useEffect(
    () => {
      if (!!onLoadOptions) return;
      if (skipValidateOptions) return;
      if (allowCustom) return; // if custom values are allowed, ignore
      if (!initialValue) return; // if value is not initialized, ignore
      let validValues = initialOptions.map(o => o?.value).filter(hasValue);
      if (useCSV) validValues = validValues.join(',');
      if (initialValue === validValues) return; // if all initial values are valid, ignore
      setTimeout(() => doCallback(setFieldValue, name, validValues), 1)
      // This is a hacky method of waiting to call setFieldValue after Formik mounts
    },
    [name, allowCustom, useCSV, setFieldValue, initialValue, initialOptions, skipValidateOptions, onLoadOptions]
  )

  // RENDER
  return <Component
    {...props}
    ref={ref}
  />
})
